import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE } from 'main/common'
import { Hidden } from 'main/ui'

import { i18nKeyPrefix as PRE } from '../../.'
import {
  Container,
  DescriptionText,
  DownloadLinksContainer,
  ImageDiv,
  LeftContainer,
  RightContainer,
  StoreLinksContainer,
  Title,
} from './DownloadApp.styles'

const STORE_LINKS = {
  googlePlay: 'https://play.google.com/store/apps/details?id=com.wonderschool.mobile',
  appStore: 'https://apps.apple.com/us/app/wonderschool/id1455389693',
}

const STORE_LOGOS = {
  googlePlay: 'https://ucarecdn.com/be004991-c6b7-42cc-a062-429786e1a1fa/',
  appStore: 'https://ucarecdn.com/dadf1e19-a976-4132-87bc-038e0558e351/',
}

export default function DownloadApp() {
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  return (
    <Container>
      <LeftContainer>
        <Title>{t(`${PRE}-DOWNLOAD-APP-TITLE`)}</Title>
        <DescriptionText>{t(`${PRE}-DOWNLOAD-APP-TXT`)}</DescriptionText>
        <DownloadLinksContainer>
          <DescriptionText>{t(`${PRE}-GET-APP-TXT`)}</DescriptionText>
          <StoreLinksContainer>
            <img
              alt="Play Store"
              src={STORE_LOGOS.googlePlay}
              onClick={() => handleOpenStoreLink(STORE_LINKS.googlePlay)}
            />
            <img
              alt="App Store"
              src={STORE_LOGOS.appStore}
              onClick={() => handleOpenStoreLink(STORE_LINKS.appStore)}
            />
          </StoreLinksContainer>
        </DownloadLinksContainer>
      </LeftContainer>
      <Hidden sm md>
        <RightContainer>
          <ImageDiv
            imageUrl="https://ucarecdn.com/94cce0c3-1a3c-46a2-81e1-de161f96fbed/"
            position="top"
          />
          <ImageDiv
            imageUrl="https://ucarecdn.com/f8f0e75d-8646-43ad-95e0-44febc5e3dfc/"
            position="bottom"
          />
        </RightContainer>
      </Hidden>
    </Container>
  )
  function handleOpenStoreLink(url: string) {
    window.open(url, '_blank')
  }
}
